// extracted by mini-css-extract-plugin
export default {"description":"kRkWCO","saleEnds":"dcAFdr"};